(function(tagId){
  function load(){
    if (window.__clarity_loaded) return; window.__clarity_loaded = true;
    (function(c,l,a,r,i,t,y){
      c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
      t=l.createElement(r); t.async=1; t.src="https://www.clarity.ms/tag/"+i;
      y=l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t,y);
    })(window, document, 'clarity', 'script', tagId);
  }
  var fired=false; function once(){ if(fired) return; fired=true; load(); }
  document.addEventListener('DOMContentLoaded', once, {once:true});
  ['pointerdown','touchstart','keydown','scroll'].forEach(e=>addEventListener(e, once, {once:true, passive:true}));
  (window.requestIdleCallback || function(cb){ setTimeout(cb, 1200); })(once);
})('rv6wp9810g');
